import { memo } from "react";
import { Info } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import type { QuestionnaireItem } from "@/types/maturity";

type CheckboxItemProps = {
  item: QuestionnaireItem;
  checked: boolean;
  onChange: (checked: boolean) => void;
  domainColor: string;
};

function CheckboxItemInner({
  item,
  checked,
  onChange,
  domainColor,
}: CheckboxItemProps) {
  const itemKey = String(item.item_index);

  return (
    <label
      htmlFor={`item-${itemKey}`}
      className="flex items-start gap-3 py-2 px-3 rounded-lg hover:bg-slate-50 cursor-pointer transition-colors group"
    >
      <Checkbox
        id={`item-${itemKey}`}
        checked={checked}
        onCheckedChange={(val) => onChange(val === true)}
        className="mt-0.5"
        style={{
          borderColor: checked ? domainColor : undefined,
          backgroundColor: checked ? domainColor : undefined,
        }}
      />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          {item.linked_category_codes.length > 0 && (
            <span className="text-[10px] font-mono text-slate-400 shrink-0">
              {item.linked_category_codes[0]}
            </span>
          )}
          <span className="text-sm text-slate-700 leading-snug">
            {item.element_name}
          </span>
          {item.assurance_level && (
            <span className="shrink-0 text-[10px] font-mono px-1.5 py-0.5 rounded bg-slate-100 text-slate-500">
              {item.assurance_level}
            </span>
          )}
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                type="button"
                className="shrink-0 text-slate-300 hover:text-slate-500 transition-colors"
                onClick={(e) => e.preventDefault()}
              >
                <Info className="w-3.5 h-3.5" />
              </button>
            </TooltipTrigger>
            <TooltipContent side="top" className="max-w-xs text-xs">
              <p className="font-medium mb-1">{item.element_name}</p>
              <p className="text-muted-foreground">
                {item.element_description}
              </p>
              {item.linked_requirement_codes.length > 0 && (
                <p className="mt-1 text-muted-foreground">
                  Cerințe: {item.linked_requirement_codes.join(", ")}
                </p>
              )}
            </TooltipContent>
          </Tooltip>
        </div>
      </div>
    </label>
  );
}

const CheckboxItem = memo(CheckboxItemInner);
export default CheckboxItem;
